// extracted by mini-css-extract-plugin
export default {"bottomBar":"FeedbackBottomToolbar_bottomBar__-8Xqw","emojiBtn":"FeedbackBottomToolbar_emojiBtn__NUOQG","emojiIcon":"FeedbackBottomToolbar_emojiIcon__1sK-P"};